



































































































































































import {
  computed,
  defineComponent,
  ref,
  onMounted
} from "@vue/composition-api";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import { JOB_EVENT_MAIL_VARIABLE_PREVIEW } from "@/helpers/jobEvent";
import OccSelectbox from "@/components/Atoms/OccSelectbox/index.vue";
import TextArea from "@/components/Atoms/Forms/TextArea/index.vue";
import OccModal from "@/components/Atoms/OccModal/index.vue";
import Caption from "@/components/Atoms/Typography/Caption/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import OccTag from "@/components/Atoms/OccTag/index.vue";
import OccCheckbox from "@/components/Atoms/OccCheckbox/index.vue";
import EmptyView from "@/components/Atoms/EmptyView/index.vue";
import ListTable from "@/components/Molecules/ListTable/index.vue";
import OccToggleCheckbox from "@/components/Atoms/OccToggleCheckbox/index.vue";
import OccAlert from "@/components/Molecules/OccAlert/index.vue";

import {
  JobEventScheduleMailKey,
  JobEventMailUpdatedAtType
} from "@/api/types";
import { useRequest } from "@/helpers/hooks/useRequest";
import { useInsertText } from "@/helpers/hooks/useInsertText";
import {
  getEventMailTemplateVariables,
  updateJobEventDraftEntryMailTemplates,
  updateJobEventEntryMailTemplates,
  getJobEventEntryMailTemplates,
  getJobEventDraftEntryMailTemplates,
  updateJobEventMailNotificationTypes
} from "@/api";
import { ApiResponse } from "@/api/types";
import { JOB_EVENT_STORE_KEY } from "@/helpers/hooks/useJobEvent";
import { occPrimary } from "@/assets/styles/vars-for-script.scss";
import { useGlobalState } from "@/helpers/hooks/useGlobalState";

export default defineComponent({
  components: {
    OccHeading,
    OccSelectbox,
    TextArea,
    OccModal,
    Caption,
    OccButton,
    OccTag,
    ListTable,
    OccCheckbox,
    EmptyView,
    OccToggleCheckbox,
    OccAlert
  },
  name: "EntryMailTemplateList",
  setup(_, { root, emit }) {
    const {
      editingJobEvent,
      refreshEditingJobEvent,
      disabledEdit,
      defaultMailTemplates,
      setEditingJobEvent
    } = useGlobalState(JOB_EVENT_STORE_KEY);

    const [{ data: mailTemplateVariables }] = useRequest(
      () => getEventMailTemplateVariables(),
      { immediate: true }
    );

    const [textareaWrapperRef, insertText] = useInsertText();

    const selectedScheduleId = Number(root.$route.params.scheduleId);

    const isDraft = computed(() => {
      // スケジュールIDがない場合は未承認のスケジュールであるため、draft_scheduleを編集対象とする
      return !selectedSchedule.value?.schedule_id;
    });

    const selectedMailKey = ref<JobEventScheduleMailKey | undefined>();
    const mailTemplates = ref<
      | ApiResponse.GetJobEventEntryMailTemplates
      | { entry_mail_template: { [key: string]: string } }
      | undefined
    >();

    const editingMailTemplate = ref<string | undefined>();

    const enabledResume = computed(
      () => !!editingJobEvent.value?.resume_questions.length
    );

    const variables: { [key: string]: string[] } = {
      entry: [
        "user_name",
        "graduate_year",
        "university_name",
        "event_title",
        "event_url",
        "schedule_info",
        "cancel_remarks",
        "resume_remarks"
      ],
      pass: [
        "user_name",
        "graduate_year",
        "university_name",
        "event_title",
        "event_url",
        "schedule_info",
        "cancel_remarks",
        "resume_remarks"
      ],
      elected: [
        "user_name",
        "graduate_year",
        "university_name",
        "event_title",
        "event_url",
        "schedule_info",
        "cancel_remarks",
        "resume_remarks"
      ],
      defeated: [
        "user_name",
        "graduate_year",
        "university_name",
        "event_title",
        "event_url",
        "schedule_info"
      ],
      reminder: [
        "user_name",
        "graduate_year",
        "university_name",
        "event_title",
        "event_url",
        "schedule_info",
        "cancel_remarks"
      ],
      user_canceled: [
        "user_name",
        "graduate_year",
        "university_name",
        "event_title",
        "event_url",
        "schedule_info"
      ],
      thanks: [
        "user_name",
        "graduate_year",
        "university_name",
        "event_title",
        "event_url",
        "schedule_info"
      ]
    };

    const filteredTemplateVariables = computed(() => {
      if (
        mailTemplateVariables.value != undefined &&
        selectedMailKey.value != undefined
      ) {
        const variablesKeys = variables[selectedMailKey.value];
        return mailTemplateVariables.value.variables.filter(variable =>
          variablesKeys.includes(variable.name)
        );
      }

      return [];
    });

    const enabledLottery = computed(() => editingJobEvent.value?.is_lottery);

    const previewText = computed(() => {
      return editingMailTemplate.value?.replace(/\${.*?}/g, variableBlock => {
        const variable = variableBlock.match(/(?<=\{).*?(?=\})/)?.[0] || "";

        const preview = JOB_EVENT_MAIL_VARIABLE_PREVIEW.find(
          ({ key }) => key === variable
        )?.previewText;

        return preview || "";
      });
    });

    const selectList = computed(() => {
      return (editingJobEvent.value?.schedules || []).map(schedule => ({
        value: schedule.id,
        label: schedule.title || "-"
      }));
    });

    const selectedSchedule = computed(() => {
      return (editingJobEvent.value?.schedules || []).find(
        schedule =>
          schedule.schedule_id === selectedScheduleId ||
          schedule.id === selectedScheduleId
      );
    });

    const headers = [
      {
        name: "メール種別",
        subHeaders: [{ name: "メール説明" }],
        minSizeContainer: "914px"
      },
      {
        name: "更新日時",
        minSizeContainer: "160px"
      },
      {
        name: "送信",
        minSizeContainer: "50px"
      },
      {
        name: "編集",
        minSizeContainer: "50px"
      }
    ];

    const selectedMailTemplate = computed(() => {
      if (selectedMailKey.value !== undefined) {
        const template =
          mailTemplates.value?.entry_mail_template[selectedMailKey.value];
        return template || "";
      }
    });

    const selectedModalTab = ref<"edit" | "preview">("edit");

    const getMailName = () => {
      return defaultMailTemplates.find(
        type => type.key === selectedMailKey.value
      )?.name;
    };

    const getDefaultMailTemplates = () => {
      const templates: { [key: string]: string } = {};
      defaultMailTemplates.map(
        template => (templates[template.key] = template.default)
      );
      return templates;
    };

    const getChecked = (mailType: JobEventScheduleMailKey) => {
      switch (mailType) {
        case "entry":
          return enabledLottery.value;
        case "pass":
          return !enabledLottery.value;
        case "elected":
          return enabledLottery.value;
        case "defeated":
          return enabledLottery.value;
        case "reminder":
          return editingJobEvent.value?.mail_notifications.reminder;
        case "thanks":
          return editingJobEvent.value?.mail_notifications.thanks;
        case "user_canceled":
          return enabledLottery.value;
      }
    };

    const onClickOpenModal = (mailType: JobEventScheduleMailKey) => {
      selectedMailKey.value = mailType;
      const template = mailTemplates.value?.entry_mail_template[mailType];

      if (template != undefined && template != "") {
        editingMailTemplate.value = template;
      } else {
        const defaultTemplate =
          defaultMailTemplates.find(
            email => email.key === selectedMailKey.value
          )?.default || "";
        editingMailTemplate.value = defaultTemplate;
      }
    };

    const onCloseModal = () => {
      selectedMailKey.value = undefined;
    };

    const onClickVariable = (name: string) => {
      const text = insertText(` \${${name}} `);
      editingMailTemplate.value = text;
    };

    const updateMailTemplate = async (
      selectedMailKey: JobEventScheduleMailKey
    ) => {
      if (selectedSchedule.value === undefined) {
        alert("スケジュールを取得できませんでした。リロードしてください。");
        return;
      }

      emit("loadMailTemplates", true);
      const entry_mail_template = selectedSchedule.value?.mail_template || {};
      entry_mail_template[selectedMailKey] = editingMailTemplate.value || "";

      if (isDraft.value) {
        await updateJobEventDraftEntryMailTemplates({
          draftScheduleId: selectedScheduleId,
          entry_mail_template: entry_mail_template
        });
      } else {
        await updateJobEventEntryMailTemplates({
          scheduleId: selectedScheduleId,
          entry_mail_template: entry_mail_template
        });
      }
      await getMailTemplates();
      emit("loadMailTemplates", false);
    };

    const onClickSaveMailTemplate = () => {
      if (
        !editingMailTemplate.value ||
        (!selectedScheduleId && selectedScheduleId !== 0) ||
        !selectedMailKey.value
      ) {
        return;
      }

      updateMailTemplate(selectedMailKey.value);
      onCloseModal();
    };

    const onClickInsertDefault = () => {
      const defaultText = defaultMailTemplates.find(
        type => type.key === selectedMailKey.value
      )?.default;

      if (defaultText) {
        const text = insertText(defaultText);
        editingMailTemplate.value = text;
      }
    };

    const onClickResetDefault = () => {
      const defaultText = defaultMailTemplates.find(
        type => type.key === selectedMailKey.value
      )?.default;

      if (defaultText) {
        editingMailTemplate.value = defaultText;
      }
    };

    const getMailTemplates = async () => {
      const res = isDraft.value
        ? await getJobEventDraftEntryMailTemplates({
            draftScheduleId: selectedScheduleId
          })
        : await getJobEventEntryMailTemplates({
            scheduleId: selectedScheduleId
          });

      mailTemplates.value =
        res.data?.entry_mail_template === null
          ? { entry_mail_template: getDefaultMailTemplates() }
          : res.data;
    };

    const mailTemplateUpdatedAt = (key: keyof JobEventMailUpdatedAtType) => {
      if (
        mailTemplates.value?.entry_mail_template === undefined ||
        mailTemplates.value?.entry_mail_template[key] === undefined
      ) {
        return "-";
      }

      const d = new Date(mailTemplates.value.entry_mail_template[key]);
      return (
        d.getFullYear() +
        "/" +
        (d.getMonth() + 1).toString().padStart(2, "0") +
        "/" +
        d
          .getDate()
          .toString()
          .padStart(2, "0") +
        " " +
        d
          .getHours()
          .toString()
          .padStart(2, "0") +
        ":" +
        d
          .getMinutes()
          .toString()
          .padStart(2, "0")
      );
    };

    const isCancelTemplate = () => {
      return selectedMailKey.value === "schedule_canceled";
    };

    const eventId = Number(root.$route.params.eventId);

    const updateMailNotificationTypes = () => {
      if (editingJobEvent.value === undefined) {
        return;
      }

      const mailNotificationTypes = [];
      if (editingJobEvent.value.mail_notifications.thanks) {
        mailNotificationTypes.push("thank_you");
      }
      if (editingJobEvent.value.mail_notifications.reminder) {
        mailNotificationTypes.push("event_remained");
      }
      if (enabledLottery.value) {
        mailNotificationTypes.push("elected", "defeated");
      }
      let params = {
        eventId: eventId,
        mail_notification_types: mailNotificationTypes
      };

      updateJobEventMailNotificationTypes(params);
    };

    const onClickCheckBox = (mailType: JobEventScheduleMailKey) => {
      switch (mailType) {
        case "reminder":
          if (editingJobEvent.value) {
            setEditingJobEvent({
              ...editingJobEvent.value,
              mail_notifications: {
                ...editingJobEvent.value.mail_notifications,
                reminder: !editingJobEvent.value.mail_notifications.reminder
              }
            });
          }
          break;
        case "thanks":
          if (editingJobEvent.value) {
            setEditingJobEvent({
              ...editingJobEvent.value,
              mail_notifications: {
                ...editingJobEvent.value.mail_notifications,
                thanks: !editingJobEvent.value.mail_notifications.thanks
              }
            });
          }
          break;
      }
      updateMailNotificationTypes();
      return;
    };

    const mailTemplateAlertMessages = computed<{
      [key: string]: string[][];
    }>(() => {
      // リマインドと参加御礼のみアラートを表示する
      const alertTargetTemplates = defaultMailTemplates.filter(
        template => template.key === "reminder" || template.key === "thanks"
      );
      return alertTargetTemplates.reduce((result, template) => {
        result[template.key] = [];
        const editedMailText =
          mailTemplates.value?.entry_mail_template[template.key];
        // editedMailTextが空の場合、デフォルトのテンプレートが利用されるためアラートは不要
        if (editedMailText && editedMailText !== "") {
          // APIで返却されるテキストには改行コードに\rが含まれているため削除して比較する
          const normalizedEditedText = editedMailText.replace(/\r/g, "");
          if (template.default !== normalizedEditedText) {
            if (
              editingJobEvent.value &&
              ((template.key === "reminder" &&
                !editingJobEvent.value.mail_notifications.reminder) ||
                (template.key === "thanks" &&
                  !editingJobEvent.value.mail_notifications.thanks))
            ) {
              result[template.key].push([
                "メール文面が編集されていますが、送信しない設定になっています。送信設定に間違いがないかご確認ください。"
              ]);
            }
            if (selectedSchedule.value && !selectedSchedule.value.start_at) {
              const notStartAlertMessage = [
                "メール文面が編集されていますが、イベント開催日程の入力がないため送信されません。"
              ];
              if (selectedSchedule.value.schedule_id) {
                notStartAlertMessage.push(
                  "※ 承認済みのスケジュールの変更はできないため、イベント開催日程を設定したい場合は新たにスケジュールの作成をお願いします。"
                );
              }
              result[template.key].push(notStartAlertMessage);
            }
          }
        }
        return result;
      }, {} as { [key: string]: string[][] });
    });

    onMounted(async () => {
      await refreshEditingJobEvent();
      await getMailTemplates();
    });

    return {
      defaultMailTemplates,
      JOB_EVENT_MAIL_VARIABLE_PREVIEW,
      editingJobEvent,
      disabledEdit,
      enabledResume,
      enabledLottery,
      mailTemplateVariables,
      filteredTemplateVariables,
      mailTemplates,
      mailTemplateUpdatedAt,

      selectList,
      selectedSchedule,
      selectedMailKey,
      selectedMailTemplate,
      editingMailTemplate,
      previewText,
      textareaWrapperRef,
      selectedModalTab,
      getMailName,
      getChecked,
      onClickOpenModal,
      onCloseModal,
      onClickVariable,
      onClickSaveMailTemplate,
      onClickInsertDefault,
      onClickResetDefault,
      insertText,
      headers,
      isDraft,
      isCancelTemplate,
      occPrimary,
      onClickCheckBox,
      mailTemplateAlertMessages
    };
  }
});
